/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type OffMarketTransferList_viewer$ref: FragmentReference;
declare export opaque type OffMarketTransferList_viewer$fragmentType: OffMarketTransferList_viewer$ref;
export type OffMarketTransferList_viewer = {|
  +offMarketTransfers: ?{|
    +count: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +account: {|
          +name: ?string,
          +id: string,
        |},
        +counterpartyAccount: {|
          +name: ?string,
          +id: string,
        |},
        +offmarkettransfercashquantitySet: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +currency: Currency,
              +quantity: number,
              +updatedAt: any,
            |}
          |}>
        |},
        +offmarkettransferholdingquantitySet: {|
          +edges: $ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +contract: {|
                +id: string,
                +symbol: string,
                +currency: Currency,
              |},
              +costBasis: number,
              +commission: number,
              +dummy: boolean,
              +portfolio: {|
                +id: string,
                +trackingVue: ?{|
                  +name: string
                |},
              |},
              +quantity: number,
            |}
          |}>
        |},
      |}
    |}>,
  |},
  +$refType: OffMarketTransferList_viewer$ref,
|};
export type OffMarketTransferList_viewer$data = OffMarketTransferList_viewer;
export type OffMarketTransferList_viewer$key = {
  +$data?: OffMarketTransferList_viewer$data,
  +$fragmentRefs: OffMarketTransferList_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  (v0/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "OffMarketTransferList_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 10
    },
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "accountId",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "offMarketTransfers",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "accountOrCounterpartyAccount",
          "variableName": "accountId"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "-createdAt"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "OffMarketTransferNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "OffMarketTransferNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "OffMarketTransferNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "account",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AccountNode",
                  "plural": false,
                  "selections": (v2/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "counterpartyAccount",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AccountNode",
                  "plural": false,
                  "selections": (v2/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "offmarkettransfercashquantitySet",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "OffMarketTransferCashQuantityNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "OffMarketTransferCashQuantityNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "OffMarketTransferCashQuantityNode",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v3/*: any*/),
                            (v4/*: any*/),
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "updatedAt",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "offmarkettransferholdingquantitySet",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "OffMarketTransferHoldingQuantityNodeConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "OffMarketTransferHoldingQuantityNodeEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "OffMarketTransferHoldingQuantityNode",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "contract",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ContractNode",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "name": "symbol",
                                  "args": null,
                                  "storageKey": null
                                },
                                (v3/*: any*/)
                              ]
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "costBasis",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "commission",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "dummy",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "portfolio",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "PortfolioNode",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "trackingVue",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "VueNode",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/)
                                  ]
                                }
                              ]
                            },
                            (v4/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '8168aa2455b673724b040f4f4fc83cdc';
module.exports = node;
